import {AmountControl} from "./amount-control.js";
import { PersonSelectChild } from "./person-select-child.js";
import {AbstractFilterComponent} from "../filter/abstract-filter-component.js";
import {FilterLabel} from "../filter/components/label.js";

export class PersonSelect extends AbstractFilterComponent {
	constructor(parent, filter, node) {
		if (!node) {
			return;
		}

		super(parent, filter, node);

		this.node = node;
		this.togglers = node.querySelectorAll('.js-person-selector-toggler');
		this.adults = node.querySelector('.js-person-selector-adults');
		this.adultsCounter = node.querySelector('.js-amount-counter-adults');
		this.adultsCounterInstance = new AmountControl(this.adultsCounter, this.adultsCounter.dataset);
		this.children = node.querySelector('.js-person-selector-children');
		this.childrenAgeDefaultValue = this.children.dataset.defaultValue || null;
		this.childrenInstances = [];
		this.childrenCount = this.children.value ? this.children.value.split(",").length : 0;
		this.childrenContainer = node.querySelector('.c-tk-person-selector__children-container');
		this.childrenCounter = node.querySelector('.js-amount-counter-children');
		this.childrenCounterInstance = new AmountControl(this.childrenCounter, this.childrenCounter.dataset);
		this.amountCounterNodes = node.querySelectorAll('.c-tk-amount-counter');
		this.amountCounters = [];
		this.value = node.querySelector('.c-tk-person-selector__value');
		this.subLabel = node.querySelector('.c-tk-person-selector__footer-label');
		this.personsWrapper = node.querySelector('.c-tk-person-selector__persons-wrapper');
		this.childLabels = this.subLabel.dataset.childLabels.split(", ");
		this.adultLabels = this.subLabel.dataset.adultLabels.split(", ");
		this.placeholder = this.value.textContent;

		this.init();
	}

	init() {
		this.toggleChildren();
		this.bindAmountCounters();
		this.updateLabel();
		this.bindTogglers();
		this.bindAdultsChange();
		this.bindChildrenChange();

		this.dispatchState();
	}

	bindAdultsChange() {
		this.adults.addEventListener('change', e => {
			this.adultsCounterInstance.setAmount(this.adults.value);
			this.updateLabel();
		});
	}

	bindChildrenChange() {
		this.children.addEventListener('change', e => {
			this.childrenCounterInstance.setAmount(this.getChildrenCount());
			this.updateLabel();
		});
	}


	getLabels() {
		const self = this;
		let labels = [];

		if (this.getAdultsCount()) {
			const adultLabel = this.adultLabels[this.getAdultsCount() - 1];

			labels.push(
				new FilterLabel(
					self,
					adultLabel,
					'adults',
				)
			)
		}

		if (this.getChildrenCount()) {
			const childrenLabel = this.childLabels[this.getChildrenCount() - 1];

			labels.push(
				new FilterLabel(
					self,
					`${childrenLabel} (${this.children.value})`,
					'children',
				)
			)
		}

		return labels;
	}

	getNode() {
		return this.node;
	}

	toggleChildren() {
		const self = this;

		this.personsWrapper.removeEventListener('click', self.initCustomSelects);
		this.personsWrapper.removeEventListener('click', self.initClosingSelects);

		for (let i = 0; i < this.getChildrenCount(); i++) {
			let defaultValue = this.children.value.split(",")[i];
			defaultValue = defaultValue ? parseFloat(defaultValue) : null;

			if (!this.childrenInstances[i]) {
				let selectChildInstance = new PersonSelectChild(self, self.childrenContainer, self.children.value.split(",")[i] || self.childrenAgeDefaultValue, i);
				selectChildInstance.onSelectChange(e => {
					let currentValue = self.children.value.split(",");
					currentValue[i] = e.target.value;
					self.children.value = currentValue.join(",");
				});

				self.renderCustomSelect(selectChildInstance.getNode());

				this.childrenInstances.push(selectChildInstance);
			}
		}

		this.personsWrapper.addEventListener('click', self.initCustomSelects.bind(this));
		this.personsWrapper.addEventListener('click', self.initClosingSelects.bind(this));

		this.getChildrenCount() ? this.childrenContainer.classList.remove('u-hidden') : this.childrenContainer.classList.add('u-hidden');
	}

	bindTogglers() {
		const self = this;

		this.togglers.forEach(toggler => toggler.addEventListener('click', function () {
			self.personsWrapper.classList.toggle('is-active');

			if (toggler.getAttribute('type') === 'button' || toggler.getAttribute('type') === 'submit') {
				document.dispatchEvent(
					new CustomEvent('person-select-change', {
						detail: self.getFormData()
					})
				)
			}
		}));
	}

	bindAmountCounters() {
		const self = this;

		// Change adults input value
		this.adultsCounter.addEventListener('changeAmount', e => {
			self.adults.value = e.detail.amount;
			this.dispatchState();
			this.adults.dispatchEvent(new Event('change'));
		});

		// Change children input value
		this.childrenCounter.addEventListener('changeAmount', e => {
			if (self.getChildrenCount() < e.detail.amount) {
				self.children.value = self.children.value + (self.childrenAgeDefaultValue ? ((self.children.value ? ',' : '') + self.childrenAgeDefaultValue) : '');
			} else if (self.getChildrenCount() > e.detail.amount) {
				let splitChildrenAges = self.children.value.split(",");
				splitChildrenAges = splitChildrenAges.slice(0, e.detail.amount);
				self.children.value = splitChildrenAges.join(",");

				self.childrenInstances[self.childrenInstances.length - 1].getNode().remove();
				self.childrenInstances.pop();
			}

			this.toggleChildren();
			this.updateLabel();
			this.dispatchState();
			this.children.dispatchEvent(new Event('change'));
		});
	}

	getChildrenCount() {
		const children = this.children.value ? this.children.value.split(",") : [];

		return children.length;
	}

	getAdultsCount() {
		return this.adults.value ? parseInt(this.adults.value) : 0;
	}

	getChildrenAgesAsArray() {
		let childrenAge = this.children.value ? this.children.value.split(",") : [];

		childrenAge = childrenAge.map(age => parseFloat(age));

		return childrenAge;
	}

	getFormData() {
		let data = {};

		if (this.getAdultsCount()) {
			data['adults'] = this.getAdultsCount();
		}

		if (this.getChildrenCount()) {
			data['children'] = this.children.value;
			data['kids'] = this.getChildrenAgesAsArray();
		}

		const numberOfPersons = parseInt(this.adults.value) + this.getChildrenCount();
		if (numberOfPersons) {
			data['numberOfPersons'] = numberOfPersons;
		}

		return data;
	}

	updateLabel() {
		this.value.textContent = this.getLabelText();
		this.subLabel.textContent = this.getSubLabel();
	}

	getLabelText() {
		const adultLabel = this.getAdultsCount();
		const childrenLabel = this.getChildrenCount();
		let label = '';

		if (adultLabel || childrenLabel) {
			label += `${adultLabel} + ${childrenLabel}`;

			return label;
		}

		return this.placeholder;
	}

	getSubLabel() {
		const adultLabel = this.getAdultsCount() ? this.adultLabels[this.adults.value - 1] : '';
		const childrenLabel = this.getChildrenCount() ? this.childLabels[this.getChildrenCount() - 1] : '';
		let label = '';

		if (adultLabel || childrenLabel) {
			label += adultLabel;

			if (adultLabel && childrenLabel) {
				label += ' • ';
			}

			label += childrenLabel;

			return label;
		}

		return this.placeholder;
	}

	initClosingSelects(e) {
		let self = this;
		const parentNode = self.personsWrapper;

		if (typeof e.target.closest !== 'function' && parentNode.querySelector('.js-selectbox.is-open')) {
			self.openSelectBox(parentNode.querySelector('.js-selectbox.is-open'), 'close');
			return;
		}

		let x = e.target.closest('.js-selectbox');


		if (!x && parentNode.querySelector('.js-selectbox.is-open')) {
			self.openSelectBox(parentNode.querySelector('.js-selectbox.is-open'), 'close');
		}

		if (x) {
			let xID = Array.prototype.slice.call(parentNode.querySelectorAll('.js-selectbox')).indexOf(x);

			parentNode.querySelectorAll('.js-selectbox').forEach(function(el, i) {
				if (i !== xID && el.classList.contains('is-open')) {
					el.classList.remove('is-open');
				}
			})
		}
	}

	initCustomSelects(e) {
		let self = this;

		let x = e.target.closest('.js-selectbox');

		if (x) {
			if (e.target.classList.contains('c-selectbox__custom-item') || e.target.closest('.c-selectbox__custom-item')) {
				self.updateOptionsArray(x, e.target.closest('.c-selectbox__custom-item').dataset.value);

				self.updateLabelText(JSON.parse(x.dataset.option), x);

				self.selectCustomItem(JSON.parse(x.dataset.option), x);

				self.updateHiddenSelect(JSON.parse(x.dataset.option), x.dataset.selectid);
			}
		}
	}

	renderCustomSelect(childrenContainer) {
		const self = this;

		let select = childrenContainer.querySelector('select');
		let selectbox = childrenContainer.querySelector('.js-selectbox');
		let options = self.optionsToArray(selectbox);
		let element = self.createCustomSelect(options);
		let label = self.createCustomLabel(options);
		let labelText = self.customLabelText(options);
		select.classList.add('is-hidden');
		selectbox.style.marginBottom = 0;

		label.innerHTML += labelText;

		selectbox.appendChild(label);

		selectbox.appendChild(element);

		self.selectCustomItem(options, selectbox);
	}

	createCustomSelect(_options) {
		let self = this;
		let selectWrapper = document.createElement('div');

		let arrayOptions = _options;

		selectWrapper.classList.add('c-selectbox__custom-select');
		selectWrapper.classList.add('c-shadow-block');

		arrayOptions.forEach(function(x) {

			if (x.optionDisabled) {
				// selectWrapper.innerHTML += `<span class="c-selectbox__custom-item is-disabled" data-value="${x.optionValue}">${x.optionText}</span>`;
				selectWrapper.innerHTML += `<span class="c-selectbox__custom-item is-disabled" data-value="${x.optionValue}"><span class="">${x.optionText}<span></span>`;
			} else {
				if (x.optionHref === false) {

					if (x.newPrice) {
						selectWrapper.innerHTML += `
							<span class="c-selectbox__custom-item" data-value="${x.optionValue}"><span class="c-selectbox__label-text">${x.optionText}</span>
								<span class="c-selectbox__label-right c-price c-price--inline c-price--in-selectbox u-pull-right prices-wrapper">
									<span class="c-price__old u-mobile-hidden">
										${x.oldPrice}
									</span>
									<span class="c-price__new">
										${x.newPrice}
									</span>
								</span>
							</span>`;
					} else {
						selectWrapper.innerHTML += `<span class="c-selectbox__custom-item" data-value="${x.optionValue}"><span class="c-selectbox__label-text">${x.optionText}<span></span>`;
					}
				} else {
					selectWrapper.innerHTML += `<a class="c-selectbox__custom-item" data-value="${x.optionValue}" href="${x.optionHref}">${x.optionText}</a>`;
				}
			}
		});

		return selectWrapper;
	}

	optionsToArray(_selector) {
		let self = this;
		let array = Array.prototype.slice.call(_selector.querySelectorAll('option'));
		let countSelectedOption = 0;
		let setDataOption = [];

		array.forEach(function(x) {
			let text = x.innerText;
			let val = x.getAttribute('value');
			let selected = x.hasAttribute('selected'); // ? true : false;
			let disabled = x.hasAttribute('disabled'); // ? true : false;
			let href = x.dataset.href ? x.dataset.href : false;
			let oldPrice = x.dataset.oldPrice ? x.dataset.oldPrice : '';
			let newPrice = x.dataset.newPrice ? x.dataset.newPrice : '';

			if (x.hasAttribute('selected')) {
				countSelectedOption++;
			}

			setDataOption.push({optionText: text, optionValue: val, optionSelected: selected, optionDisabled: disabled, optionHref: href, oldPrice: oldPrice, newPrice: newPrice});
		});

		if (countSelectedOption === 0) {
			setDataOption[0].optionSelected = true;
		}

		_selector.dataset.option = JSON.stringify(setDataOption);

		return setDataOption;
	}

	createCustomLabel(_options) {
		let self = this;
		let labelWrapper = document.createElement('div');

		labelWrapper.classList.add('c-selectbox__custom-label');

		return labelWrapper;
	}


	customLabelText(_options) {
		let text;

		_options.forEach(function(x) {
			if (x.optionSelected === true) {
				text = `<span class="c-selectbox__label-text">${x.optionText}</span>`
			}
		});

		return text;
	}

	selectCustomItem(_options, _selector) {
		let selected;

		_options.forEach(function(x) {
			if (x.optionSelected) {
				selected = x.optionValue;
			}
		});

		Array.prototype.slice.call(_selector.querySelectorAll('.c-selectbox__custom-item')).forEach(function(x) {
			x.classList.remove('is-active');

			if (x.dataset.value === selected) {
				x.classList.add('is-active');
			}
		})
	}

	openSelectBox(_selector, _state) {
		if (_state === 'toggle') {
			_selector.classList.toggle('is-open');
		} else {
			if (_selector !== null) {
				_selector.classList.remove('is-open');
			}
		}
	}

	updateHiddenSelect(_options, _selectid) {
		if (! _selectid) {
			return;
		}

		let select = document.getElementById(_selectid);
		let opts = select.options;
		let option = '';

		_options.forEach(function(x) {
			if (x.optionSelected === true) {
				option = x.optionValue;
			}
		});

		for (var opt, j = 0; opt = opts[j]; j++) {
			if (opt.value === option) {
				select.selectedIndex = j;
				break;
			}
		}

		// remove invalid class on active option change
		select.closest('.js-selectbox').classList.remove('c-selectbox--invalid');

		// standard `change` event dispatching
		select.dispatchEvent(new CustomEvent('change'));

		/**
		 * reservation calendar is listening to it
		 */
		select.dispatchEvent(new CustomEvent('selectbox-changed'));
	}

	updateLabelText(_options, _selector) {
		let self = this;

		let labelText = self.customLabelText(_options);

		_selector.querySelector('.c-selectbox__custom-label').innerHTML = labelText;
	}

	updateOptionsArray(_selector, _value) {
		let self = this;
		let options = JSON.parse(_selector.dataset.option);

		options.forEach(function(x) {
			x.optionSelected = x.optionValue === _value;
		});

		_selector.dataset.option = JSON.stringify(options);
	}

	labelDismissed(data) {
		let self = this;

		if (self[data.parameters]) {
			self[`${data.parameters}Counter`].dispatchEvent(new CustomEvent('changeAmount', { detail: { amount: 0 }}));
		}

		this.updateLabel();
		self.filter.setForceUpdateMode();
		self.node.dispatchEvent(new CustomEvent('change'));
	}

	dispatchState() {
		document.dispatchEvent(
			new CustomEvent('person-select-set', {
				detail: {
					adults: parseInt(this.adults.value),
					children: this.children.value,
					kids: this.getChildrenAgesAsArray(),
					numberOfPersons: parseInt(this.adults.value) + this.getChildrenCount(),
				}
			})
		)
	}
}
